/**
 * Schema param keys that can be normalized from input_schema default.
 */
const NORMALIZABLE_SCHEMA_KEYS = new Set([
  'material',
  'generate_type',
  'polygon_type',
  'face_count',
  'face_level',
  'target_polycount',
])

/**
 * Returns true if the schema param is one we can normalize (has a store mapping and we apply default).
 */
export function canNormalizeSchemaParam(schemaKey) {
  return NORMALIZABLE_SCHEMA_KEYS.has(schemaKey)
}
